module.exports = __webpack_public_path__ + "img/delete.cebe7818.svg";